import React from 'react'
import styles from '../styles/footer.module.css'

function Footer() {
  return (
    <div className={styles.footer}>
      <h3 style={{
        margin: '0',
      }}>Made with 💓 and ☕ by 
      Sandeepan Mohanty</h3>
    </div>
  )
}

export default Footer
